import { render, staticRenderFns } from "./ModalImportDeliveryCSV.vue?vue&type=template&id=2c176cde&scoped=true&"
import script from "./ModalImportDeliveryCSV.vue?vue&type=script&lang=ts&"
export * from "./ModalImportDeliveryCSV.vue?vue&type=script&lang=ts&"
import style0 from "./ModalImportDeliveryCSV.vue?vue&type=style&index=0&id=2c176cde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c176cde",
  null
  
)

export default component.exports